import { render } from "./VolumeQuitIcon.vue?vue&type=template&id=3d7e3946"
import script from "./VolumeQuitIcon.vue?vue&type=script&lang=js"
export * from "./VolumeQuitIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__